import { Button, Flex, Heading, View } from '@adobe/react-spectrum';
import { AddOnType, StudentPaymentData } from '../../types';
import styles from '../../../../styles.module.scss';
import { emptyAddOns, FeesStatus } from '../constant';
import { useState } from 'react';
import SummarySection from './summarySection';
import FeesRecords from './feesRecords';
import PersonalDetails from './personalDetails';
import PaymentMethod from './paymentMethod';
import AddOnsList from './addOnsList';

const PaymentDetailsOverview = ({ studentData }: { studentData: StudentPaymentData }) => {
  const fixAmountPerMonth = 3000;
  const [localStudentData, setLocalStudentData] = useState(studentData);
  const [finalCostComponent, setFinalCostComponent] = useState<AddOnType[]>([]);
  const handleCalculated = () => {
    const totalCount = localStudentData.feesDetails.filter((item) => item.feesStatus === FeesStatus.INPROCESS).length;
    const costComponent = { title: 'Tuition Fees', amount: (totalCount * fixAmountPerMonth).toString() };
    setFinalCostComponent([costComponent, ...addons]);
  };
  const [addons, setAddons] = useState<AddOnType[]>([]);
  const handleAddOns = () => {
    setAddons([...addons, emptyAddOns]);
  };

  return (
    <View UNSAFE_className={styles.card} marginTop={'size-100'}>
      <Heading margin={0} level={4}>
        Payment Overview
      </Heading>
      <PersonalDetails studentData={localStudentData} />
      <FeesRecords localStudentData={localStudentData} setLocalStudentData={setLocalStudentData} />
      {addons.length > 0 && <AddOnsList setAddons={setAddons} addons={addons} />}
      <Flex width={'100%'} justifyContent={'end'} marginTop={'size-100'} gap={'size-100'}>
        <Button
          width={'size-2000'}
          justifySelf={'end'}
          variant="primary"
          isDisabled={
            !localStudentData.feesDetails.some((item) => item.feesStatus === FeesStatus.INPROCESS) ||
            (addons.length > 0 && (addons.some((item) => item.title === '') || addons.some((item) => item.amount === '')))
          }
          onPress={handleAddOns}
        >
          Add Ons
        </Button>
        <Button
          width={'size-2000'}
          justifySelf={'end'}
          variant="cta"
          isDisabled={
            !localStudentData.feesDetails.some((item) => item.feesStatus === FeesStatus.INPROCESS) ||
            (addons.length > 0 && (addons.some((item) => item.title === '') || addons.some((item) => item.amount === '')))
          }
          onPress={handleCalculated}
        >
          Calculate
        </Button>
      </Flex>
      {finalCostComponent.length > 0 && <SummarySection finalCostComponent={finalCostComponent} />}
      <PaymentMethod localStudentData={localStudentData} finalCostComponent={finalCostComponent} />
    </View>
  );
};

export default PaymentDetailsOverview;
